<template>
  <v-dialog
    v-model="value"
    :persistent="false"
    width="800"
    content-class="filial-menu-export-dialog"
    @close="close"
  >
    <v-card class="filial-menu-export-dialog_inner">
      <h1 class="text-center">
        Экспорт основно меню
      </h1>
      <h3 class="text-center">
        Используйте ссылки ниже для экспорта меню филиала в различные сервисы
      </h3>
      <div class="filial-menu-export-dialog_links">
        <b>YAML:</b>
        <a :href="yamlFeedUrl" target="_blank"> {{ yamlFeedUrl }}</a>
      </div>

      <v-card-actions class="d-flex j-center">
        <v-btn
          color="primary"
          depressed
          large
          @click="close"
        >
          ОК
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import md5 from 'crypto-js/md5'
  import getFilialYmlFeedLink from '@/util/filial-yml-feed-link'

  export default {
    name: 'ExportDialog',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      filialId: {
        type: Number,
        default: null,
      },
    },
    computed: {
      ...mapGetters({
        baseUrl: 'api/getBaseWebApiUrl',
      }),
      yamlFeedUrl () {
        return getFilialYmlFeedLink(this.filialId, this.baseUrl)
        /* const hash = md5(`filial.id.${this.filialId}`)
        return `${this.baseUrl}/feed/yaml/${this.filialId}/${hash}` */
      },
    },
    methods: {
      close () {
        this.$emit('close')
        this.$emit('input', false)
      },

    },
  }
</script>

<style scoped lang="less">
.filial-menu-export-dialog {
  &_inner {
    padding: 30px 30px 20px 30px;
    border-radius: 10px;
  }

  &_links {
    text-align: center;
    padding: 30px;
  }
}
</style>
